// AL-ANSARI theme scripts. Every feature degrades to plain HTML without JS.
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Announcement bar rotation
  $$('[data-rotator]').forEach((el) => {
    const msgs = $$('.announcement__msg', el);
    if (msgs.length < 2) return;
    let i = 0;
    setInterval(() => {
      msgs[i].classList.remove('is-active');
      i = (i + 1) % msgs.length;
      msgs[i].classList.add('is-active');
    }, 4500);
  });

  // Header: transparent over a first-position hero, solid after scrolling
  const header = $('.site-header');
  const firstHero = $('main > .shopify-section:first-child .hero');
  if (firstHero) firstHero.classList.add('is-first');
  if (header) {
    if (firstHero) header.classList.add('is-overlay');
    const onScroll = () => header.classList.toggle('is-scrolled', scrollY > 40);
    onScroll();
    addEventListener('scroll', onScroll, { passive: true });
  }

  // Search bar toggle
  const searchBar = $('#HeaderSearch');
  const setSearch = (open) => {
    if (!searchBar) return;
    if (open) {
      searchBar.hidden = false;
      requestAnimationFrame(() => searchBar.classList.add('is-open'));
      $('input', searchBar).focus();
    } else {
      searchBar.classList.remove('is-open');
      // keep it in the DOM until the slide-up finishes, then hide it from everyone
      searchBar.addEventListener('transitionend', function off(e) {
        if (e.target !== searchBar) return;
        searchBar.removeEventListener('transitionend', off);
        if (!searchBar.classList.contains('is-open')) searchBar.hidden = true;
      });
    }
    $$('[aria-controls="HeaderSearch"]').forEach((b) => b.setAttribute('aria-expanded', open));
  };
  $$('[data-search-toggle]').forEach((btn) =>
    btn.addEventListener('click', () => setSearch(searchBar.hidden))
  );
  addEventListener('keyup', (e) => e.key === 'Escape' && setSearch(false));

  // Menu drawer close button + Escape
  $$('.menu-drawer').forEach((d) => {
    $('.menu-drawer__close', d)?.addEventListener('click', () => d.removeAttribute('open'));
    d.addEventListener('keyup', (e) => e.key === 'Escape' && d.removeAttribute('open'));
  });

  // Reveal on scroll
  const io = new IntersectionObserver(
    (entries) => entries.forEach((e) => {
      if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); }
    }),
    { rootMargin: '0px 0px -10% 0px' }
  );
  $$('.reveal, .stagger').forEach((el) => io.observe(el));
  // split headlines reveal themselves (the hero one fires immediately, it is above the fold)
  setTimeout(() => $$('[data-split]').forEach((el) => io.observe(el)), 0);

  // Headlines rise word by word
  $$('[data-split]').forEach((el) => {
    if (reduced) return;
    const words = el.textContent.trim().split(/\s+/);
    el.innerHTML = words
      .map((w) => `<span class="split-line"><span>${w}</span></span>`)
      .join(' ');
  });

  // Pointer-tracked glow in the hero
  const heroGlow = $('.hero');
  if (heroGlow && !reduced) {
    heroGlow.addEventListener('pointermove', (e) => {
      const r = heroGlow.getBoundingClientRect();
      heroGlow.style.setProperty('--mx', `${((e.clientX - r.left) / r.width) * 100}%`);
      heroGlow.style.setProperty('--my', `${((e.clientY - r.top) / r.height) * 100}%`);
    });
  }

  // Numbers count up once on screen
  const counters = new IntersectionObserver((entries) => {
    entries.forEach((e) => {
      if (!e.isIntersecting) return;
      counters.unobserve(e.target);
      const end = parseFloat(e.target.dataset.count) || 0;
      if (reduced) { e.target.textContent = end; return; }
      const t0 = performance.now();
      const tick = (now) => {
        const p = Math.min((now - t0) / 1100, 1);
        e.target.textContent = Math.round(end * (1 - Math.pow(1 - p, 3)));
        if (p < 1) requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);
    });
  }, { rootMargin: '0px 0px -15% 0px' });
  $$('[data-count]').forEach((el) => counters.observe(el));

  // Hero video pause/play (WCAG: moving content must be pausable)
  $$('[data-video-toggle]').forEach((btn) => {
    const videos = $$('video', btn.closest('.hero'));
    if (reduced) { videos.forEach((v) => v.pause()); btn.classList.add('is-paused'); }
    btn.addEventListener('click', () => {
      const paused = btn.classList.toggle('is-paused');
      videos.forEach((v) => (paused ? v.pause() : v.play()));
      btn.setAttribute('aria-label', paused ? 'Play video' : 'Pause video');
    });
  });

  // Product rails: arrows + progress bar
  $$('[data-rail]').forEach((rail) => {
    const track = $('.rail__track', rail);
    const bar = $('.rail__progress span', rail.parentElement);
    const step = () => track.clientWidth * 0.8;
    $('[data-rail-prev]', rail.parentElement)?.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
    $('[data-rail-next]', rail.parentElement)?.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
    const update = () => {
      if (!bar) return;
      const w = Math.min(100, (track.clientWidth / track.scrollWidth) * 100);
      const max = track.scrollWidth - track.clientWidth;
      bar.style.width = w + '%';
      bar.style.left = (max ? (track.scrollLeft / max) * (100 - w) : 0) + '%';
    };
    track.addEventListener('scroll', update, { passive: true });
    addEventListener('resize', update);
    update();
  });

  // Gentle parallax on story/banner images
  const parallax = $$('[data-parallax]');
  if (parallax.length && !reduced) {
    let ticking = false;
    const run = () => {
      parallax.forEach((el) => {
        const r = el.parentElement.getBoundingClientRect();
        if (r.bottom < 0 || r.top > innerHeight) return;
        const p = (r.top + r.height / 2 - innerHeight / 2) / innerHeight; // -1..1
        el.style.transform = `translate3d(0, ${p * -6}%, 0)`;
      });
      ticking = false;
    };
    addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(run); } }, { passive: true });
    run();
  }

  // Quantity steppers
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-qty]');
    if (!b) return;
    const input = $('input', b.closest('.qty'));
    input.value = Math.max(+input.min || 0, (+input.value || 0) + +b.dataset.qty);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  // AJAX add to cart (falls back to normal form post)
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[action*="/cart/add"]');
    if (!form || !window.fetch) return;
    e.preventDefault();
    const btn = $('[type=submit]', form);
    const label = btn.innerHTML;
    btn.disabled = true;
    try {
      const res = await fetch(window.routes.cart_add_url + '.js', {
        method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form)
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || 'Could not add to cart');
      const cart = await (await fetch(window.routes.cart_url + '.js')).json();
      $$('[data-cart-count]').forEach((el) => { el.textContent = cart.item_count; el.hidden = !cart.item_count; });
      btn.innerHTML = 'Added ✦';
      setTimeout(() => { btn.innerHTML = label; btn.disabled = false; }, 1800);
    } catch (err) {
      btn.innerHTML = label; btn.disabled = false;
      alert(err.message);
    }
  });

  // Variant picker
  $$('[data-product]').forEach((root) => {
    const variants = JSON.parse($('[data-variants]', root).textContent);
    const idInput = $('input[name=id]', root);
    const price = $('[data-price]', root);
    const buttons = $$('[data-add-button]');
    // ponytail: handles {{amount}} formats only; add no_decimals/comma variants if the store currency needs them
    const money = (c) => window.moneyFormat.replace(/\{\{\s*\w+\s*\}\}/, (c / 100).toFixed(2));
    root.addEventListener('change', (e) => {
      if (!e.target.matches('[data-option]')) return;
      const chosen = $$('fieldset.option', root).map((f) => $('input:checked', f).value);
      const v = variants.find((x) => x.options.every((o, i) => o === chosen[i]));
      buttons.forEach((b) => {
        b.disabled = !v || !v.available;
        b.textContent = !v ? 'Unavailable' : v.available ? 'Add to cart' : 'Sold out';
      });
      if (!v) return;
      idInput.value = v.id;
      price.innerHTML = v.compare_at_price > v.price
        ? `<s>${money(v.compare_at_price)}</s><span class="price--sale">${money(v.price)}</span>`
        : money(v.price);
      history.replaceState(null, '', `?variant=${v.id}`);
    });
  });

  // Sticky mobile add-to-cart bar
  const mainAtc = $('[data-main-atc]');
  const sticky = $('.sticky-atc');
  if (mainAtc && sticky) {
    new IntersectionObserver(([e]) => sticky.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0)).observe(mainAtc);
    $('button', sticky).addEventListener('click', () => mainAtc.closest('form').requestSubmit());
  }

  // Cart page: quantity changes apply straight away, no "Update cart" needed
  (() => {
    const form = $('#CartForm');
    if (!form || !window.routes?.cart_change_url) return;
    const money = (c) => window.moneyFormat.replace(/\{\{\s*\w+\s*\}\}/, (c / 100).toFixed(2));

    const change = async (key, quantity, row) => {
      row?.classList.add('is-busy');
      try {
        const res = await fetch(window.routes.cart_change_url + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: key, quantity })
        });
        const cart = await res.json();
        if (!res.ok) throw new Error(cart.description || 'Could not update the cart');
        if (cart.item_count === 0) { location.reload(); return; }   // show the empty state

        if (quantity === 0) row?.remove();
        cart.items.forEach((item) => {
          const r = $(`[data-line-item="${item.key}"]`);
          if (!r) return;
          const price = $('[data-line-price]', r);
          if (price) price.textContent = money(item.final_line_price);
          const qty = $('[data-line-qty]', r);
          if (qty && +qty.value !== item.quantity) qty.value = item.quantity;
        });
        $$('[data-cart-subtotal]').forEach((el) => (el.textContent = money(cart.items_subtotal_price)));
        $$('[data-cart-total]').forEach((el) => (el.textContent = money(cart.total_price) + ' ' + cart.currency));
        $$('[data-cart-count]').forEach((el) => { el.textContent = cart.item_count; el.hidden = !cart.item_count; });
      } catch (err) {
        row?.classList.remove('is-busy');
        form.submit();   // fall back to the plain form post
        return;
      }
      row?.classList.remove('is-busy');
    };

    form.addEventListener('change', (e) => {
      const input = e.target.closest('[data-line-qty]');
      if (!input) return;
      change(input.dataset.lineQty, Math.max(0, +input.value || 0), input.closest('.cart-item'));
    });

    form.addEventListener('click', (e) => {
      const remove = e.target.closest('[data-line-remove]');
      if (!remove) return;
      e.preventDefault();
      change(remove.dataset.lineRemove, 0, remove.closest('.cart-item'));
    });
  })();

  // Filter drawer: close on the X, on a backdrop click, or on Escape
  $$('.filter--drawer').forEach((drawer) => {
    const close = () => drawer.removeAttribute('open');
    $('[data-drawer-close]', drawer)?.addEventListener('click', close);
    drawer.addEventListener('click', (e) => {
      // clicks land on the <details> itself only when they hit the dimmed backdrop
      if (e.target === drawer) close();
    });
    addEventListener('keyup', (e) => { if (e.key === 'Escape' && drawer.open) close(); });
  });

  // Sorting applies straight away; filters wait for their Apply button
  $$('[data-submit-on-change]').forEach((el) =>
    el.addEventListener('change', () => el.form?.requestSubmit())
  );
})();

// Login page: toggle between sign-in and password recovery
(() => {
  const login = document.getElementById('CustomerLoginForm');
  const recover = document.getElementById('RecoverPassword');
  if (!login || !recover) return;
  const show = (wantRecover) => {
    login.hidden = wantRecover;
    recover.hidden = !wantRecover;
  };
  document.querySelectorAll('[data-recover-toggle]').forEach((a) =>
    a.addEventListener('click', (e) => { e.preventDefault(); show(a.getAttribute('href') === '#recover'); })
  );
  if (location.hash === '#recover' || recover.querySelector('.form-message')) show(true);
})();
